/**
 * Lake Charles Landing Page - Main Entry Point
 *
 * This is the React app entry point for Lake Charles's landing page.
 * Migrated from legacy lake-charles-landing/ to modern multi-city architecture.
 *
 * Build: CITY=louisiana/lake-charles npm run build:city
 * Dev: CITY=louisiana/lake-charles npm run dev:city
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import '../../../src/index.css'; // Shared styles

// NOTE: a pdfjs-dist worker used to be configured here "for PDF parsing", but
// no code in landing-pages or src/ ever called it (the parser feature never
// landed). Removed 2026-07-31 along with the root pdfjs-dist dependency.

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);
